import { IDishContent, ISeatingContent, IVersionedObject } from "../planEatApi/PlanEatFacade";

export function getDistinctDishesOnSeatings(dishes: IVersionedObject<IDishContent>[], seatings: IVersionedObject<ISeatingContent>[]){
     // Get all dishes on date
     let allDishesOnSeatings: string[] = []
     if (seatings.length > 0) {
        seatings.forEach((seating) => {
             if (seating.content.seatingDishes) {
                seating.content.seatingDishes.forEach((seatingDish) => {
                    allDishesOnSeatings.push(seatingDish.dishId)
                 })
             }
         })
     }

    // Filter to find unique dishes
    const uniqueDishIds = allDishesOnSeatings.filter((n, i) => allDishesOnSeatings.indexOf(n) === i);
    return dishes.filter(dish => uniqueDishIds.includes(dish.content.id))
}